import { MenuItem, Spinner, Tooltip, useToast } from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { colors } from 'packages/common-frontend/colors';
import { Icon } from 'packages/common-frontend/components/icons';
import { successToastConfig } from 'packages/common-frontend/constants';
import {
  GetInvoiceByIdDocumentGQLType,
  GetInvoicesByLoanIdDocumentGQLType,
  GetInvoicesByOrganizationIdDocumentGQLType,
  useMarkInvoiceAsCanceledMutation,
} from 'packages/invoices/requests/invoices.gql.generated';
import { GetResolvedLoanByIdDocumentGQLType } from 'packages/loans/requests/loans.gql.generated';

export const CancelAndRedoInvoiceButton = ({
  invoiceId,
}: {
  invoiceId: string;
}) => {
  const toast = useToast();
  const navigate = useNavigate();

  const [
    cancelInvoice,
    { loading: isCancelInvoiceLoading },
  ] = useMarkInvoiceAsCanceledMutation({
    onCompleted: () => {
      toast({
        ...successToastConfig,
        title: 'Successfully marked invoice as canceled.',
      });

      navigate(`/invoices/create/prefill/${invoiceId}`);
    },
    refetchQueries: [
      GetInvoiceByIdDocumentGQLType,
      GetInvoicesByOrganizationIdDocumentGQLType,
      GetInvoicesByLoanIdDocumentGQLType,
      GetResolvedLoanByIdDocumentGQLType,
    ],
  });

  return (
    <Tooltip label="Cancel current invoice and prefill new invoice">
      <MenuItem
        icon={
          isCancelInvoiceLoading ? <Spinner /> : <Icon icon="rotate-right" />
        }
        color={colors.gray[800]}
        onClick={async () =>
          cancelInvoice({
            variables: {
              invoiceId,
            },
          })
        }
        isDisabled={isCancelInvoiceLoading}
      >
        Cancel And Redo
      </MenuItem>
    </Tooltip>
  );
};
